module.exports = __webpack_public_path__ + "img/man-qrcode.b777037b.png";